import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders, Type } from '@angular/core';

/**
 * Interface for burgerprofiel contact action handlers
 */
export interface _BaasBurgerprofielContactActionHook {
    /** The action code this handler responds to */
    readonly code: string;
    /** Execute the action */
    execute(): void;
}

/**
 * Injection token for registering burgerprofiel contact action handlers
 * Use multi: true when providing to register multiple handlers
 */
export const _BAAS_BURGERPROFIEL_CONTACT_ACTION = new InjectionToken<_BaasBurgerprofielContactActionHook>(
    'Hook for contact actions which should invoke custom logic.'
);

/**
 * Provides a burgerprofiel contact action hook that will be invoked when a user clicks
 * a contact action link in the burgerprofiel widget.
 */
export function _provideBaasBurgerprofielContactAction<T extends _BaasBurgerprofielContactActionHook>(type: Type<T>): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: _BAAS_BURGERPROFIEL_CONTACT_ACTION,
            useClass: type,
            multi: true
        }
    ]);
}
